import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import base_url from "../../api";
import "../LoginPage/LoginPage.css";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const validateEmail = (email) => {
    if (!email.trim()) {
      return "Email is required";
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email.trim())) {
      return "Please enter a valid email address";
    }
    return "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const emailError = validateEmail(email);
    if (emailError) {
      toast.error(emailError, { position: "top-right" });
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${base_url}/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setEmailSent(true);
        toast.success(data.message || "Password reset link sent to your email!", {
          position: "top-right",
          autoClose: 3000,
        });
      } else {
        // Show specific error message from backend
        toast.error(data.message || "Failed to send reset link. Please try again.", {
          position: "top-right",
          autoClose: 4000,
        });
      }
    } catch (err) {
      toast.error("Something went wrong. Please try again later.", {
        position: "top-right",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-left" style={{ maxWidth: "500px", margin: "0 auto" }}>
        <h2>Forgot Password</h2>
        
        {emailSent ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <p style={{ fontSize: "16px", marginBottom: "20px", color: "#28a745" }}>
              ✅ Password reset link has been sent to your email!
            </p>
            <p style={{ fontSize: "14px", color: "#666", marginBottom: "20px" }}>
              Please check your inbox and click on the link to reset your password.
            </p>
            <Link to="/login" className="btn" style={{ display: "inline-block", marginTop: "10px" }}>
              Back to Login
            </Link>
          </div>
        ) : (
          <>
            <p style={{ marginBottom: "20px", color: "#666" }}>
              Enter your email address and we'll send you a link to reset your password.
            </p>
            <form className="login-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="email"
                  placeholder="Email address*"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <button type="submit" className="btn" disabled={loading}>
                {loading ? "Sending..." : "Send Reset Link"}
              </button>
            </form>

            <div style={{ marginTop: "20px", textAlign: "center" }}>
              <Link to="/login" className="btn" style={{ display: "inline-block" }}>
                ← Back to Login
              </Link>
            </div>
          </>
        )}
      </div>
      <ToastContainer />
    </div>
  );
};

export default ForgotPassword;

